import MaintainerHelper from 'features/Maintainer/maintainerHelper';
import KTFormTextArea from 'general/components/OtherKeenComponents/Forms/KTFormTextArea';
import AppColors from 'general/constants/AppColors';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

DialogMaintainerReconciliationFeedback.propTypes = {
    reconciliation: PropTypes.object.isRequired,
    onCancel: PropTypes.func,
    onDone: PropTypes.func,
    adminRole: PropTypes.bool,
};

function DialogMaintainerReconciliationFeedback({ reconciliation, adminRole, onCancel, onDone }) {
    // MARK: ---- PROPERTIES ----
    const [loading, setLoading] = useState(false);
    const [readyToValidate, setReadyToValidate] = useState(false);
    const [feedback, setFeedback] = useState('');

    useEffect(() => {
        if (reconciliation) {
            setFeedback(reconciliation?.feedback ?? '');
        }
    }, [reconciliation])
    // MARK: ---- METHODS ----
    const handleSubmit = async () => {
        setReadyToValidate(true);
        if (!Utils.isValid(feedback)) {
            ToastHelper.showError('Vui lòng điền đủ thông tin');
            return;
        }
        setLoading(true);
        const res = await MaintainerHelper.API.requestCreateFeedbackReconciliation(
            {
                reconciliationId: reconciliation?.reconciliationId,
                feedback: feedback,
            }
        );
        if (_.isBoolean(res) && res) {
            ToastHelper.showSuccess('Gửi phản hồi thành công');
            if (onDone) {
                onDone();
            }
        } else if (_.isString(res)) {
            ToastHelper.showError(res);
        }
        setLoading(false);
    };

    return (
        <div>
            <div className="row m-0 p-0 px-2">
                <div className="col-12 mb-4 px-2">
                    <div>
                        {UIHelper.buildFormLabel('Lý do', true)}
                        <KTFormTextArea
                            placeholder="Nhập lí do"
                            rows={5}
                            name="feedback"
                            value={feedback}
                            onChange={(value) => {
                                setFeedback(value);
                            }}
                            enableCheckValid={true}
                            isValid={Utils.isValid(feedback)}
                            isTouched={readyToValidate}
                            feedbackText={!Utils.isValid(feedback) ? 'Vui lòng nhập lí do' : ''}
                        />
                    </div>
                </div>
            </div>

            {/* footer */}
            {!adminRole
                ? (
                    <div
                        className="d-flex align-items-center justify-content-end gap-3 px-4 py-3"
                        style={{
                            borderTop: `1px solid ${AppColors.gray[200]}`,
                        }}
                    >
                        {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null, true)}
                        {UIHelper.buildGreenButton('Gửi', handleSubmit, null, true, loading)}
                    </div>
                )
                : (
                    <div
                        className="d-flex align-items-center justify-content-end gap-3 px-4 py-3"
                        style={{
                            borderTop: `1px solid ${AppColors.gray[200]}`,
                        }}
                    >
                        {UIHelper.buildNegativeButton('Đóng', onCancel, null, true)}
                    </div>
                )}
        </div>
    );
}

export default DialogMaintainerReconciliationFeedback;
